var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { openAlreadyRegisteredDialog } from '../../dialogs';
import { isHTTPPostOrSSOOnInAccount, isOAuthOnInAccount } from '../../redux/selectors/shared';
import { isExternalAuthOnInEvent, isOAuthOnInEvent, isSpecificRegPathAuthLocation } from '../../redux/selectors/event';
import { PostRegistrationAuthType } from 'event-widgets/utils/postRegistrationAuthType';
import { getCurrentPageId, getPagePath, isInviteeInUrl, redirectToExternalAuth, redirectToOAuthURL } from '../../redux/pathInfo';
import { Accepted, PendingApproval } from 'event-widgets/utils/InviteeStatus';
import { canLogin } from '../../redux/selectors/currentRegistrant';
import * as EventStatus from 'event-widgets/clients/EventStatus';
export function createLinkClickHandler(title, registerNowText) {
    var _this = this;
    return function () {
        return function (dispatch, getState) { return __awaiter(_this, void 0, Promise, function () {
            var _a, postRegistrationAuthType, attendeeLoginClient, isPreview, account, event;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = getState(), postRegistrationAuthType = _a.event.eventSecuritySetupSnapshot.postRegistrationAuthType, attendeeLoginClient = _a.clients.attendeeLoginClient, isPreview = _a.defaultUserSession.isPreview, account = _a.account, event = _a.event;
                        if (!(!isPreview && handleAuthenticationRedirection(account, event))) return [3 /*break*/, 1];
                        return [2 /*return*/];
                    case 1:
                        if (!(postRegistrationAuthType === PostRegistrationAuthType.SECURE_VERIFICATION_CODE)) return [3 /*break*/, 3];
                        return [4 /*yield*/, attendeeLoginClient.authorize()];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, dispatch(openAlreadyRegisteredDialog({
                            title: title,
                            registerNowText: registerNowText
                        }))];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
    };
}
export function isAlreadyRegisteredLinkDisabled(state) {
    var _a = state.defaultUserSession, isPlanner = _a.isPlanner, isPreview = _a.isPreview, isArchived = state.event.isArchived;
    return (isArchived || !canLogin(state) || !shouldShowLinkToInvitee(state)) && !isPlanner && !isPreview;
}
export function isEventCancelled(state) {
    return state.event.status === EventStatus.CANCELLED;
}
function shouldShowLinkToInvitee(state) {
    /*
     * Already registered link should be shown when no invitee has been identified.
     * If an invitee has been identified, we should not show the link when its status is not in an accepted status
     */
    return (!isInviteeInUrl(getPagePath(state, getCurrentPageId(state))) ||
        [Accepted, PendingApproval].includes(state.userSession.inviteeStatus));
}
function handleAuthenticationRedirection(account, event) {
    if (isHTTPPostOrSSOOnInAccount(account) && isExternalAuthOnInEvent(event)) {
        if (!isSpecificRegPathAuthLocation(event)) {
            redirectToExternalAuth(event, account);
            return true;
        }
    }
    else if (isOAuthOnInAccount(account) && isOAuthOnInEvent(event)) {
        if (!isSpecificRegPathAuthLocation(event)) {
            redirectToOAuthURL(event);
            return true;
        }
    }
    return false;
}
